import styled from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';
import rem from 'polished/lib/helpers/rem';

import color from '@decisiv/design-tokens/lib/color';
import spacing from '@decisiv/design-tokens/lib/spacing';

import Flex from '@decisiv/ui-components/lib/components/Flex';

export const FiltersContainer = styled(Flex)`
  background-color: ${toColorString(color.opacity.fullMoon50)};
  border-top: 1px solid ${toColorString(color.base.fullMoon)};

  gap: ${rem(spacing.base)};
`;
